import list from './list'
import create from './create'
import update from './update'
import show from './show'
import del from './delete'
import showModal from './showModal'
import generateFromPositionsModal from './generateFromPositionsModal'
import createModal from './createModal'
import acceptModal from './acceptModal'

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    showModal,
    generateFromPositionsModal,
    createModal,
    acceptModal
  }
}
